export const ROLES = Object.freeze({
  SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
});
